import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ items = [] }) => {
  const location = useLocation();
  
  const pathMap = {
    '/analytics-dashboard': 'Dashboard',
    '/joint-assessments': 'Assessments',
    '/compliance-reports': 'Reports',
    '/pay-band-management': 'Pay Bands',
    '/data-integration': 'Data Integration',
    '/employee-portal': 'My Pay',
    '/settings': 'Settings',
    '/help': 'Help'
  };

  const generateBreadcrumbs = () => {
    if (items?.length > 0) {
      return items;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/analytics-dashboard' }];
    
    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = pathMap?.[currentPath] || segment?.charAt(0)?.toUpperCase() + segment?.slice(1)?.replace(/-/g, ' ');
      breadcrumbs?.push({ label, path: currentPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6">
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
          )}
          {index === breadcrumbs?.length - 1 ? (
            <span className="text-foreground font-medium">{crumb?.label}</span>
          ) : (
            <Link
              to={crumb?.path}
              className="hover:text-foreground transition-smooth"
            >
              {crumb?.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;